<div class='row' *ngFor="let group of productGroups">
  <div class='col'>

    <div class='row mt-2 small'>
      <div class='col'>
        <strong>Gruppe: {{group.Name}}</strong>
      </div>

    </div>

    <div class='row small mt-2'>
      <div class='col-6'>
        <strong>Produkte</strong>
      </div>

      <div class="col-2">
        <strong>Anzahl</strong>
      </div>

      <div class='col-2'>
        <strong>Einzelpreis Brutto</strong>
      </div>

      <div class='col-2'>
        <strong>Preis Brutto</strong>
      </div>
    </div>

    <div class='row mt-2 small' *ngFor="let product of getProductByGroup(group.Id)">

      <div class='col'>
        <item-form [type]="type" [product]="product" [item]="getItem(product)" (updateEmitter)="update($event)">
        </item-form>
      </div>

    </div>

    <div class='row mt-2 small' [ngClass]="getClass(group.Id)">

      <div class='col-2 offset-8'>
        <strong>Summe Brutto:</strong>
      </div>

      <div class='col-2'>
        <strong>{{getSum(group.Id) | nbDecimal }} &euro;</strong>
      </div>

    </div>

    <div class='row small' *ngIf="!checkSum(group.Id) && showWarning">
      <div class='col'>
        <p class='text-warning'>
          Der Gesamtpreis liegt über der Freibetragsgrenze von zurzeit {{getPauschale() | nbDecimal }} &euro;.
        </p>
      </div>
    </div>

    <hr>
  </div>

</div>